module.exports = __webpack_public_path__ + "img/Jet Wings.b391f66a.svg";